import { StoresInstance } from "Custom/Stores";
// Libraries
import { observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

export class ProductsModel extends ModelBase<ProductsModel, ProductsModelDTO> {
    constructor() {
        super();

        const showRoofSystem: boolean = StoresInstance.domain.showRoofOptions;

        if (showRoofSystem === true) {
            this.products.push({ title: "Roof system", value: "id_roofsystem_only" });
        }

        this.products.push({ title: "Gutter system", value: "id_guttersystem_only" });

        /*         if (showRoofSystem === true) {
            this.products.push({ title: "Roof and gutter system", value: "id_roofandgutter" });
        } */
        this.productSelection = this.products[0];
    }

    // #region Model Properties

    @observable
    public products = observable<any>([]);

    @observable
    public productSelection: any = undefined;

    // #region Model Properties

    public fromDto(model: ProductsModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(model: ProductsModel): ProductsModelDTO {
        return {};
    }
}

export interface ProductsModelDTO {}
